// src/app/services/accessDoorApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IAccessDoor, IAccessDoorParams, UpdatePayload } from '../models';

export const accessDoorApi = createApi({
  reducerPath: 'accessDoorApi',
  baseQuery,
  endpoints: (builder) => ({
    getAccessDoorParams: builder.query<
      { access_door: IAccessDoorParams },
      void
    >({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/access_door/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
      transformResponse: (data: { access_door: IAccessDoorParams }) => {
        data.access_door.mounting_plane =
          data.access_door.mounting_plane.filter((el) => el.id < 7);
        return data;
      },
    }),
    getAccessDoor: builder.query<IAccessDoor, number>({
      query: (id) => `/api/v1.0/ahu/access_doors/${id}`,
      transformResponse: (data: IAccessDoor) => {
        data.viewportParams = data.viewport_params
          ? JSON.parse(data.viewport_params)
          : {};
        return data;
      },
    }),
    getAllViewportsCount: builder.query<{ count: number }, void>({
      query: () =>
        `/api/v1.0/cms/1/v1.0.0/ahu/access_door/viewports/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getViewportsCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/access_door/viewports/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    updateAccessDoor: builder.mutation<IAccessDoor, UpdatePayload<IAccessDoor>>(
      {
        query: ({ id, body, signal }) => ({
          url: `/api/v1.0/ahu/access_doors/${id}`,
          method: 'PATCH',
          body,
          signal,
        }),
        transformResponse: (data: IAccessDoor) => {
          data.viewportParams = data.viewport_params
            ? JSON.parse(data.viewport_params)
            : {};
          return data;
        },
      }
    ),
    createAccessDoor: builder.mutation<any, UpdatePayload<any>>({
      query: ({ body, signal }) => ({
        url: `/api/v1.0/ahu/access_doors/`,
        method: 'POST',
        body,
        signal,
      }),
    }),
  }),
});

export const {
  useLazyGetAccessDoorQuery,
  useGetAccessDoorParamsQuery,
  useGetAllViewportsCountQuery,
  useLazyGetViewportsCountQuery,
  useUpdateAccessDoorMutation,
  useCreateAccessDoorMutation,
} = accessDoorApi;

// Access Door API service - helpers moved to apiHelpers.ts